export { default } from './CookieBotDeclarationBlock';
